import React, { useEffect, useState, useContext } from "react";
import { Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";

import { getStocksByBoatOwner } from "../../../../api/stock/getStockApi";
import { getCourierByUserId } from "../../../../api/courier/courierApi";
import { getPlantByUserId } from "../../../../api/processing plant/plantApi";
import { FaCamera, FaEdit, FaRegTrashAlt } from "react-icons/fa";
import DataTable from "react-data-table-component";
import { motion } from "framer-motion";
import { AuthContext } from "../../../ExtraPages/AuthProvider";
import ImageCropModal from "./ImageCropModal";
import "./stocks.css";
import boatImage from "../../../../assets/images/boat-image.jpg";
const MyStockPage = () => {
  const navigate = useNavigate();
  const [allStocks, setAllStocks] = useState([]);
  const [courierNames, setCourierNames] = useState({});
  const [plantNames, setPlantNames] = useState({});
  const { user } = useContext(AuthContext);
  const [userId, setUserId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [stockId, setStockId] = useState("");
  const [tripNumber, setTripNumber] = useState("");
  const [key, setKey] = useState(1);
  const setStockModalOpen = (stockId1, tripNumber1) => {
    setStockId(stockId1);
    setTripNumber(tripNumber1);
    setModalOpen(true);
  };

  useEffect(() => {
    if (!user) return;
    setUserId(user.uid);
  }, [user]);

  const customStyles = {
    table: {
      style: {
        tableLayout: "auto", // Let content define width
      },
    },
    headCells: {
      style: {
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        wordBreak: "break-word",
        whiteSpace: "nowrap",
        maxWidth: "150px",
        paddingLeft: "10px",
        paddingRight: "10px",
      },
    },
    cells: {
      style: {
        paddingLeft: "10px",
        paddingRight: "10px",
      },
    },
  };

  const columns = [
    { name: "Boat Number", selector: (row) => row.Boat_Number, sortable: true },
    {
      name: "Product Name",
      selector: (row) => row.Product_Name,
      sortable: true,
      tableLayout: "auto",
      wrap: true,
    },
    {
      name: "Created Date",
      selector: (row) => {
        if (!row.Last_Date_Of_Catch) return "-";
        const date = new Date(row.Last_Date_Of_Catch);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      },
      sortable: true,
    },
    {
      name: "Quantity",
      selector: (row) => row.Size_Weight,
      sortable: true,
    },
    {
      name: "Available",
      selector: (row) => row.Total_Available_Quantity,
      sortable: true,
    },
    {
      name: "Unit Price (kg)",
      selector: (row) => row.Price_per_Kg,
      sortable: true,
    },
    // {
    //   name: "Processing Plant",
    //   selector: (row) =>
    //     plantNames[row.Processing_Plant_Id] || row.Processing_Plant_Id || "N/A",
    //   sortable: true,
    // },
    // {
    //   name: "Processing<br /> Status",
    //   selector: (row) => row.Processing_Plant_status,
    //   sortable: true,
    //   wrap: true,
    //   cell: (row) => (
    //     <>
    //       {row.Processing_Plant_status === "true" ? (
    //         <span className="status-button-success">Approved</span>
    //       ) : row.Processing_Plant_status === "false" ? (
    //         <span className="status-button-danger">Rejected</span>
    //       ) : (
    //         <span className="status-button-warning">Pending</span>
    //       )}
    //     </>
    //   ),
    // },
    // {
    //   name: "Courier",
    //   selector: (row) =>
    //     courierNames[row.Courier_id] || row.Courier_id || "N/A",
    //   sortable: true,
    // },
    // {
    //   name: "Courier Status",
    //   selector: (row) => row.Courier_Status,
    //   sortable: true,
    //   cell: (row) => (
    //     <>
    //       {row.Courier_Status === "true" ? (
    //         <span className="status-button-success">Approved</span>
    //       ) : row.Courier_Status === "false" ? (
    //         <span className="status-button-danger">Rejected</span>
    //       ) : (
    //         <span className="status-button-warning">Pending</span>
    //       )}
    //     </>
    //   ),
    // },
    {
      name: "Stock Image",
      selector: (row) => row.Vessel_Thumb,
      cell: (row) =>
        row.Vessel_Thumb ? (
          <img
            key={key}
            src={row.Vessel_Thumb}
            alt="Stock"
            className="stock-image"
            style={{ width: "50%" }}
          />
        ) : (
          <img
            key={key}
            src={boatImage}
            alt="Stock"
            className="stock-image"
            style={{ width: "50%" }}
          />
        ),
    },
    {
      name: "Published Status",
      cell: (row) => (
        <>
          {!row.Vessel_Thumb ||
          !row.Total_Available_Quantity ||
          !row.Product_Name ||
          !row.Price_per_Kg ? (
            <span className="status-button-danger">Not Listed</span>
          ) : (
            <span className="status-button-success">Listed</span>
          )}
        </>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <>
          <Button
            color="primary"
            onClick={() => setStockModalOpen(row.Stock_id, row.Trip_Number)}
            className="btn btn-primary p-2 pt-1 pb-1"
            title="Upload Stock Image"
          >
            <FaCamera />
          </Button>
          <Button
            color="primary"
            onClick={() => navigate(`/addStock/${row._id}`)}
            className="btn btn-primary ms-2 p-2 pt-1 pb-1"
            title="Edit Stock"
          >
            <FaEdit />
          </Button>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  useEffect(() => {
    const fetchStocksAndRelatedData = async () => {
      if (!userId) return;
      try {
        const stockResponse = await getStocksByBoatOwner(userId);
        const stocks = stockResponse.data.data || [];
        console.log("Fetched stocks:", stocks);
        setAllStocks(stocks);

        const courierIds = [
          ...new Set(
            stocks.map((stock) => stock.Courier_id).filter((id) => id)
          ),
        ];

        console.log("courier ids ", courierIds);
        const plantIds = [
          ...new Set(
            stocks.map((stock) => stock.Processing_Plant_Id).filter((id) => id)
          ),
        ];

        const courierPromises = courierIds.map(async (id) => {
          const courierResponse = await getCourierByUserId(id);
          return {
            id,
            name: courierResponse.data.data.companyName || "Unknown",
          };
        });
        const couriers = await Promise.all(courierPromises);
        const courierMap = couriers.reduce((acc, { id, name }) => {
          acc[id] = name;
          return acc;
        }, {});
        setCourierNames(courierMap);

        const plantPromises = plantIds.map(async (id) => {
          const plantResponse = await getPlantByUserId(id);
          console.log("Plant Response:", plantResponse);
          return { id, name: plantResponse.data.companyName || "Unknown" };
        });
        const plants = await Promise.all(plantPromises);
        const plantMap = plants.reduce((acc, { id, name }) => {
          acc[id] = name;
          return acc;
        }, {});
        setPlantNames(plantMap);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };

    fetchStocksAndRelatedData();
  }, [userId]);
  const onImageUpload = (url) => {
    console.log("Image uploaded to:", url);
    setUploadedImageUrl(url);
  };

  const refreshComponent = async () => {
    const stockResponse = await getStocksByBoatOwner(userId);
    const stocks = stockResponse.data.data || [];
    setAllStocks(stocks);
    setKey((prev) => prev + 1);
  };
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <div style={{ minHeight: "100%" }}>
        <Container fluid>
          <div style={{ overflowX: "auto" }}>
            <Card style={{ backgroundColor: "#fff" }}>
              <CardBody style={{ padding: "20px" }}>
                <h5 className="mb-4">My Stocks</h5>
                <DataTable
                  columns={columns}
                  data={allStocks}
                  customStyles={customStyles}
                  pagination
                  noDataComponent="No stocks available."
                />
                <ImageCropModal
                  isOpen={modalOpen}
                  onClose={() => setModalOpen(false)}
                  onUpload={onImageUpload}
                  Stock_id={stockId}
                  Trip_Number={tripNumber}
                  refreshComponent={refreshComponent}
                />
              </CardBody>
            </Card>
          </div>
        </Container>
      </div>
    </motion.div>
  );
};

export default MyStockPage;
